'use client'
import React, { ReactNode, useEffect, useState } from 'react'
import useUpdatefilterValues from '@/src/components/Filter-Component/hooks/useUpdatefilterValues'
import Popup from '@/src/components/popup'
import Cookies from 'js-cookie'
import { useStore } from '@/src/types/store'
import NewHeader from '@/src/components/header/newHeader'
import NewSideBar from '@/src/components/sidebar/newSideBar'
import WarningPopup from '@/src/components/popup/WarningPopup'
import { useRouter } from 'next/router'

interface LayoutProps {
  children: ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const router = useRouter()
  const { homeTheme, showSidebar, setShowSidebar } = useStore()
  const [pathname, setPathname] = useState<string | null>(null)

  useUpdatefilterValues()

  useEffect(() => {
    if (router.isReady) {
      setPathname(router.pathname)
    }
  }, [router.isReady, router.pathname])

  const user_id = Cookies.get('user_id')

  const announcementCheck =
    pathname &&
    (pathname.includes('announcement') ||
      pathname.includes('news-insights') ||
      pathname.includes('research') ||
      pathname === '/corporate' ||
      pathname.includes('terms') ||
      pathname.includes('view-dns') ||
      pathname.includes('maintainance-mode') ||
      pathname === '/' ||
      pathname.includes('login') ||
      pathname.includes('homepage-preview'))

      return (
        <div className="flex-col h-screen w-full bg-[#F5F5F8]">
          {homeTheme?.central_banner && <WarningPopup />}
          {!announcementCheck && <NewHeader toggleSidebar={() => setShowSidebar(!showSidebar)} />}

          {user_id && <Popup />}

          <div
            className={`flex overflow-hidden ${
              announcementCheck
                ? 'h-full'
                : user_id
                  ? 'h-[calc(100vh_-_123px)]'
                  : 'h-[calc(100vh_-_65px)]'
            } w-full`}
          >
            {!announcementCheck && showSidebar && (
              <div className="transition-all duration-300">
                <NewSideBar />
              </div>
            )}

            <main
              className={`${
                showSidebar && !announcementCheck
                  ? 'w-full min-w-0 sm:w-[calc(100vw-56px)] lg:w-[calc(100vw-230px)]'
                  : 'w-full min-w-0'
              }  h-full`}
            >
              {children}
            </main>
          </div>
        </div>
      )
}

export default Layout
